/**
 * 企业微信在线客服相关公共方法
 * 客服链接来自企业微信「客服工具」配置，点击后跳转到微信客服会话
 */
export const CUSTOMER_SERVICE_URL = 'https://work.weixin.qq.com/kfid/kfcfd036b24a820527a';

export function openCustomerService() {
  window.location.href = CUSTOMER_SERVICE_URL;
}
